import { useEffect, useMemo } from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { ThemeProvider, CssBaseline } from '@mui/material'
import { CacheProvider } from '@emotion/react'
import { getTheme } from './theme'
import { rtlCache, ltrCache } from './emotionCache'
import { HomePage } from './Pages/HomePage'
import { FloatingButtons } from './Components/FloatingButtons'
import { Footer } from './Components/Footer'
import { AllProjects } from './Pages/AllProjects'
import { AllBlogs } from './Pages/AllBlogs'
import { AboutUsPages } from './Pages/AboutUsPages'
import { ContactUsPage } from './Pages/ContactUsPage'
import { ProjectDetails } from './Pages/ProjectDetails'
import { BlogDetails } from './Pages/BlogDetails'
import { Dashboard } from './Pages/Dashboard'
import { LoginPage } from './Pages/LoginPage'
import { PrivateRoute } from './utility/PrivateRoute'

function App() {
  const { i18n } = useTranslation()
  const isRtl = i18n.language?.startsWith('ar')

  useEffect(() => {
    document.documentElement.dir = isRtl ? 'rtl' : 'ltr'
    document.documentElement.lang = i18n.language
  }, [isRtl, i18n.language])

  const theme = useMemo(() => getTheme(isRtl ? 'rtl' : 'ltr', i18n.language), [isRtl, i18n.language])

  return (
    <CacheProvider value={isRtl ? rtlCache : ltrCache}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <FloatingButtons />
        {/* الفوتر لازم يكون جوه BrowserRouter عشان روابط <Link> جوّاه تشتغل،
            وبرة Routes عشان يتعرض مرة واحدة بس فوق كل الصفحات */}
        <BrowserRouter>
          <Routes>
            <Route path="/lyorauraauthlogin" element={<LoginPage />} />

            <Route
              path="/lyorauradashboard"
              element={
                <PrivateRoute>
                  <Dashboard />
                </PrivateRoute>
              }
            />

            <Route path="/" element={<HomePage />} />
            <Route path="/projects" element={<AllProjects />} />
                <Route path="/projects/:id" element={<ProjectDetails />} />

            <Route path="/blogs" element={<AllBlogs />} />
                <Route path="/blogs/:slug" element={<BlogDetails />} />

            <Route path="/about" element={<AboutUsPages />} />
            <Route path="/contact" element={<ContactUsPage />} />
          </Routes>
          <Footer />
        </BrowserRouter>
      </ThemeProvider>
    </CacheProvider>
  )
}

export default App